@if (brand == 'prixtel') {
    <app-vitrine-menu></app-vitrine-menu>
}
@if (brand == 'coriolis') {
    <app-vitrine-menu-coriolis></app-vitrine-menu-coriolis>
}

<div [id]="'wrapper-' + brand" class="wpx_wrap">
    @if (brand == 'lacarte') {
        <a href="{{ vitrineUrl }}" class="logo"></a>
    }
    <app-breadcrumb [breadcrumb]="breadcrumbDetails" [brand]="brand"></app-breadcrumb>
</div>

@if (step == 1) {
    <div [id]="'login-form-' + brand" class="row form_container">
        <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <div class="card card-signin my-5">
                <div class="card-body text-center">
                    <h1 class="card-title text-center blue-color">Changer l'e-mail de mon compte client</h1>
                    <div class="text-left pb-3">
                        <strong>Vous souhaitez changer l'e-mail associé à votre compte client ?</strong>
                        <br/>1. Saisissez l'e-mail que vous souhaitez associer à votre compte (il ne doit pas être
                        utilisé par un autre compte).
                        <br/>2. Indiquez le numéro de téléphone de votre ligne mobile.
                        <br/>3. Un code de vérification vous sera transmis par SMS ou par appel vocal sur le numéro de
                        téléphone renseigné.
                    </div>
                    @if (captchaKey) {
                        <form class="form" [formGroup]="restLoginSmsForm">
                            <div class="form-group">
                                <label for="inputEmail" class="bold-label-text float-left align-left">Votre nouvel
                                    e-mail*</label>
                                <input type="text" id="inputEmail" class="form-control" placeholder="Email"
                                       formControlName="email" required>
                                @if (restLoginSmsFormSubmitted && restLoginSmsForm.controls.email.errors) {
                                    <p class="error-message">Veuillez saisir un email valide. Vérifiez que vous n'avez
                                        pas oublié le "@" ou le "." .</p>
                                }
                            </div>
                            <div class="form-group">
                                <label for="inputPhoneNumber" class="bold-label-text float-left align-left">Votre numéro
                                    de ligne mobile*</label>
                                <input type="text" id="inputPhoneNumber" class="form-control" placeholder="Numéro"
                                       formControlName="phoneNumber" required>
                                @if (restLoginSmsFormSubmitted && restLoginSmsForm.controls.phoneNumber.errors) {
                                    <p class="error-message">Veuillez saisir un numéro valide. Il doit commencer par 0
                                        et contenir 10 chiffres.</p>
                                }
                            </div>
                            <re-captcha #captchaRefSms="reCaptcha" (resolved)="resolved($event)" size="invisible"
                                        [siteKey]="captchaKey" (error)="errored(captchaRefSms)"
                                        errorMode="handled"></re-captcha>
                            <button type="submit" class="cta_btn level_2"
                                    (click)="onLoginClick(captchaRefSms, 'sendSms')">Recevoir le code de
                                vérification<span></span></button>
                            <button class="cta_cancel" (click)="backToLoginPage()">Annuler<span></span></button>
                        </form>
                    }
                    @if (errorMessage !== null) {
                        <div class="error-message text-center">{{ errorMessage }}</div>
                    }
                </div>
            </div>
        </div>
    </div>
}

@if (step == 2) {
    <div [id]="'login-form-' + brand" class="row form_container">
        <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <div class="card card-signin my-5">
                <div class="card-body text-center">
                    <h1 class="card-title text-center blue-color">Changer l'e-mail de mon compte client</h1>
                    <div class="text-left pb-3">
                        Saisissez le code de vérification que vous avez reçu sur votre téléphone
                        <br/>
                        afin que nous puissions vous envoyer un e-mail avec vos nouveaux identifiants.
                    </div>
                    @if (captchaKey) {
                        <form class="form" [formGroup]="restLoginByCodeForm">
                            <div class="form-group">
                                <label for="inputCode" class="bold-label-text float-left">Code*</label>
                                <input type="text" id="inputCode" class="form-control" placeholder="Code"
                                       formControlName="code" required>
                                @if (restLoginByCodeFormSubmitted && restLoginByCodeForm.controls.code.errors) {
                                    <p class="error-message">Ce champ est obligatoire.</p>
                                }
                            </div>
                            <re-captcha #captchaRefByCode="reCaptcha" (resolved)="resolved($event)" size="invisible"
                                        [siteKey]="captchaKey"></re-captcha>
                            <div class="bloc_cta">
                                <button type="submit" class="cta_btn level_2"
                                        (click)="onLoginClick(captchaRefByCode, 'resetByCode')">Réinitialiser mes
                                    identifiants<span></span></button>
                            </div>
                        </form>
                    }
                    @if (errorMessageCode !== null) {
                        <div class="error-message text-center">{{ errorMessageCode }}</div>
                    }
                    @if (brand == 'prixtel') {
                        <div class="text-left pb-3 pt-2">
                            Vous n'avez pas reçu le code de vérification ? Merci de saisir le numéro d'une de vos
                            factures.
                        </div>
                    }
                    @if (captchaKey && brand == 'prixtel') {
                        <form class="form" [formGroup]="restLoginByBillIdForm">
                            <div class="form-group">
                                <label for="billId" class="bold-label-text float-left">N° de facture*</label>
                                <input type="text" id="billId" class="form-control" placeholder="N° de facture"
                                       formControlName="billId" required>
                                @if (restLoginByBillIdFormSubmitted && restLoginByBillIdForm.controls.billId.errors) {
                                    <p class="error-message">Ce champ est obligatoire.</p>
                                }
                            </div>
                            <re-captcha #captchaRefByBillId="reCaptcha" (resolved)="resolved($event)" size="invisible"
                                        [siteKey]="captchaKey"></re-captcha>
                            <div class="bloc_cta">
                                <button type="submit" class="cta_btn level_2"
                                        (click)="onLoginClick(captchaRefByBillId, 'resetByBillId')">Réinitialiser mes
                                    identifiants<span></span></button>
                            </div>
                        </form>
                    }
                    @if (errorMessageBillId !== null) {
                        <div class="error-message text-center">{{ errorMessageBillId }}</div>
                    }
                </div>
            </div>
        </div>
    </div>
}

@if (step == 3) {
    <div [id]="'login-form-' + brand" class="row form_container">
        <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <div class="card card-signin my-5">
                <div class="card-body text-center">
                    <h1 class="card-title text-center blue-color">Changer l'e-mail de mon compte client</h1>
                    Un email avec vos identifiants<br/>a été envoyé à l'adresse suivante : <strong>{{ email }}</strong>
                    <br/>
                    <div class="bloc_cta">
                        <button type="button" class="cta_btn level_2" (click)="backToLoginPage()">Retour à la page
                            d'identification<span></span></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

@if (brand == 'prixtel') {
    <app-vitrine-footer></app-vitrine-footer>
}
@if (brand == 'coriolis') {
    <app-vitrine-footer-coriolis></app-vitrine-footer-coriolis>
}
